import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

interface DropZoneContentProps {
  maxSize: number;
}

export const DropZoneContent = ({ maxSize }: DropZoneContentProps) => {
  const { t } = useTranslation("common");

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <FileText className="h-8 w-8 text-muted-foreground" />
      <p className="mt-2 text-sm text-muted-foreground">
        <span className="font-semibold">{t("editor.dropzoneClickToUpload")}</span> {t("editor.dropzoneOrDragDrop")}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">{t("editor.dropzonePdfOnly")}</p>
      <p className="text-xs text-muted-foreground">{t("editor.dropzoneMaxSize", { size: maxSize / 1024 / 1024 })}</p>
    </div>
  );
};
